import { render } from "./VehiclesView.vue?vue&type=template&id=0c9c9010&ts=true"
import script from "./VehiclesView.vue?vue&type=script&lang=ts"
export * from "./VehiclesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__